import { createFileRoute } from '@tanstack/react-router'
import { ResetPassword } from '../components/auth/ResetPassword'

export const Route = createFileRoute('/reset-password')({
  component: ResetPassword,
})
